<script>
  import Image from '../Comment/Attachments/Image.svelte';
  import DefaultAvatar from '../../Common/DefaultAvatar.svelte';
  import CommentAdminService from '../service';
  import { onMount } from 'svelte';
  import { External } from '../../external';

  let isAvatarChanged = false;
  export let member = {
    extra: {
      avatar: null
    }
  };

  const fileInput = {
    accept: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.wbmp', '.ico', '.svg', '.webp', '.avif'].join(', '),
    element: null,
    selectedFile: null,
    selectedFileSrc: null,
    onChanged: () => {
      fileInput.selectedFile = fileInput.element.files[0];
      fileInput.readFile(fileInput.selectedFile);
      isAvatarChanged = true;
    },
    readFile: (file) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        fileInput.selectedFileSrc = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    click: () => {
      fileInput.element.click();
    },
    clear: () => {
      fileInput.element.value = '';
      fileInput.selectedFile = null;
      fileInput.selectedFileSrc = null;
    },
    remove: () => {
      fileInput.clear();
    }
  };

  onMount(async () => {
    if (member?.extra?.avatar && Object.keys(member?.extra?.avatar).length > 0) {
      fileInput.selectedFileSrc =
        External.getThumbnailsFromBase(member?.extra?.avatar.base + '/', '640x480') +
        member?.extra?.avatar.name +
        '?format=webp';
    }
  });

  const onDelete = () => {
    isAvatarChanged = true;
    fileInput.remove();
  };

  export const getResult = async () => {
    if (!fileInput.selectedFile) {
      return { changed: isAvatarChanged, image: {} };
    }

    const newImage = await CommentAdminService.uploadAdminAvatarImageAndReturnDetails(fileInput.selectedFile);

    return { changed: isAvatarChanged, image: newImage };
  };
</script>

{#if fileInput.selectedFileSrc}
  <Image
    wrapperClasses="comment-image-wrapper"
    imageSrc={fileInput.selectedFileSrc}
    expandable={false}
    showDelete={true}
    {onDelete} />
{:else}
  <div on:click={fileInput.click} on:keypress={fileInput.click}>
    <DefaultAvatar wrapperClasses="circle-post-author-image" identifier={member.id} name={member.name} />
  </div>
{/if}

<input
  type="file"
  accept={fileInput.accept}
  class="none"
  bind:this={fileInput.element}
  on:change={fileInput.onChanged} />
